export const DymekConversationRetention=Object.freeze({
  mode:'ephemeral_memory',
  persisted:false,
  retentionUntil:'runtime_reset_or_user_clear'
});

export const DymekProviderPrivacyRequirements=Object.freeze({
  promptRetention:'zero',
  providerTraining:'disabled',
  secondaryUse:'prohibited',
  rawContentLogging:'prohibited'
});

export const DymekPrivacyDisclosure=Object.freeze({
  title:'Prywatność Dymka',
  summary:'Rozmowa Dymka jest domyślnie przechowywana tylko w pamięci bieżącej sesji aplikacji. Dymek korzysta najpierw z lokalnie zapisanych faktów.',
  privateText:'Prywatne notatki są dołączane tylko do konkretnego pytania po osobnym zaznaczeniu.',
  provider:'Treść pytania i minimalny kontekst mogą zostać wysłane do skonfigurowanego dostawcy AI tylko po osobnej zgodzie dla tego pytania. Dostawca musi mieć wyłączone trenowanie i retencję treści.',
  analytics:'Treść pytań, odpowiedzi, notatek, receptur i nazw sesji nie trafia do ogólnych analytics ani logów operacyjnych.',
  delete:'Wyczyść rozmowę usuwa bieżącą historię z pamięci aplikacji. Dymistrz 0.8 nie utrwala treści rozmów Dymka na serwerze.'
});

function boolean(value){return value===true;}

export function createDymekRequestConsent({
  privateTextNeeded=false,
  privateTextConsent=false,
  providerProcessingConsent=false
}={}){
  const wantsPrivate=boolean(privateTextNeeded);
  const privateConsent=boolean(privateTextConsent);
  if(wantsPrivate&&!privateConsent){
    throw new Error('DYMEK_PRIVATE_TEXT_CONSENT_REQUIRED');
  }
  return Object.freeze({
    privateTextIncluded:wantsPrivate&&privateConsent,
    providerProcessingConsent:boolean(providerProcessingConsent),
    conversationRetention:DymekConversationRetention.mode
  });
}

export function assertDymekProviderPrivacyConfiguration(config={}){
  const retention=String(config.promptRetention??'').trim().toLowerCase();
  const training=String(config.providerTraining??'').trim().toLowerCase();
  const secondaryUse=String(config.secondaryUse??'').trim().toLowerCase();
  const rawLogging=String(config.rawContentLogging??'').trim().toLowerCase();

  if(retention!=='zero')throw new Error('DYMEK_PROVIDER_RETENTION_NOT_ZERO');
  if(training!=='disabled')throw new Error('DYMEK_PROVIDER_TRAINING_NOT_DISABLED');
  if(secondaryUse!=='prohibited')throw new Error('DYMEK_PROVIDER_SECONDARY_USE_NOT_PROHIBITED');
  if(rawLogging!=='prohibited')throw new Error('DYMEK_PROVIDER_RAW_LOGGING_NOT_PROHIBITED');

  return DymekProviderPrivacyRequirements;
}

export function providerProcessingDecision({
  consent,
  providerAvailable=false
}={}){
  if(!providerAvailable){
    return Object.freeze({allowed:false,reason:'PROVIDER_UNAVAILABLE'});
  }
  if(consent?.providerProcessingConsent!==true){
    return Object.freeze({allowed:false,reason:'PROVIDER_CONSENT_REQUIRED'});
  }
  return Object.freeze({allowed:true,reason:'ALLOWED'});
}

export function dymekPrivacySnapshot(){
  return Object.freeze({
    conversation:DymekConversationRetention,
    provider:DymekProviderPrivacyRequirements,
    disclosure:DymekPrivacyDisclosure,
    genericAnalyticsRawContent:false,
    diagnosticsRawContent:false,
    privateTextConsentPerRequest:true,
    providerConsentPerRequest:true
  });
}
